import { FeatureFlags, useFeatureFlags } from './featureFlags';
import { useFetch } from './fetch';

export const useIsMaintenance = () => {
  const { isFeatureActive } = useFeatureFlags();

  const { isLoading, serverError, apiData } = useFetch(
    'GET',
    `${process.env.REACT_APP_BACKEND_API_URL}/rcm/maintenance`,
    {},
    false,
  );

  return {
    isLoading,
    isMaintenance: isFeatureActive(FeatureFlags.FITCF0356)
      ? (apiData as unknown as boolean)
      : false,
    serverError,
  };
};
